import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";

import { $api } from "@/lib/api";
import { routePaths } from "@/router/route-paths";

interface ApiError {
  statusCode: number;
}

export const useUser = () => {
  const navigate = useNavigate();
  const { user: auth0User, isAuthenticated, logout } = useAuth0();

  const enabled = isAuthenticated;

  const { data: user, failureReason } = $api.useQuery(
    "get",
    "/v1/users/me",
    {},
    {
      enabled,
    },
  );

  // Handle 403 Forbidden - user doesn't have agency access
  useEffect(() => {
    const apiError = failureReason as ApiError | undefined;

    if (apiError?.statusCode === 403) {
      void navigate(routePaths.logout);
    }
  }, [failureReason, logout, navigate]);

  const enabledCertificateTypes = user?.settings?.enabledCertificateTypes;
  const agencyFeatures = user?.settings?.features;

  return { user, auth0User, enabledCertificateTypes, agencyFeatures };
};
